import { ITimesheet } from '@jobcost-monorepo/crud/dto/timesheet';

import dayjs from '@jobcost-monorepo/dayjs-config';
import {
  ITimesheetsByDate,
  ITimesheetsByResourceByDate,
} from '@jobcost-monorepo/utils';

export function groupDataForDate(
  timesheets: ITimesheet[],
): ITimesheetsByResourceByDate[] {
  const resourceMap: Map<string, Map<string, ITimesheet[]>> = new Map();

  timesheets.forEach((timesheet) => {
    const resourceKey = timesheet.resourceId.toString(); // Usa direttamente resourceId e convertilo a stringa
    const operationDateKey = dayjs
      .utc(timesheet.operationDate)
      .format('YYYY-MM-DD');

    if (!resourceMap.has(resourceKey)) {
      resourceMap.set(resourceKey, new Map());
    }

    const dateMap = resourceMap.get(resourceKey)!;

    if (!dateMap.has(operationDateKey)) {
      dateMap.set(operationDateKey, []);
    }

    dateMap.get(operationDateKey)!.push(timesheet);
  });

  const result: ITimesheetsByResourceByDate[] = [];

  resourceMap.forEach((dateMap, resourceKey) => {
    const groupedByDate: ITimesheetsByDate[] = [];

    dateMap.forEach((timesheets, operationDateKey) => {
      groupedByDate.push({
        operationDate: new Date(operationDateKey),
        timesheets,
      });
    });

    const resource = timesheets.find(
      (timesheet) => timesheet.resourceId.toString() === resourceKey,
    )?.resource || { id: resourceKey, name: '' };

    result.push({
      resource,
      groupedByDate,
    });
  });

  return result;
}
